// src/store/index.js
import { createStore } from "vuex";

export default createStore({
  state: {
    jwt: localStorage.getItem("traineeToken") || null, // Initialize the state from localStorage
    cancelledInfo: null // Transient { message, firstName } passed from Auth.vue to Cancelled.vue
  },
  mutations: {
    setJwt(state, token) {
      state.jwt = token;
    },
    clearJwt(state) {
      state.jwt = null;
    },
    setCancelledInfo(state, info) {
      state.cancelledInfo = info;
    },
    clearCancelledInfo(state) {
      state.cancelledInfo = null;
    }
  },
  actions: {
    saveJwt({ commit }, token) {
      localStorage.setItem("traineeToken", token); // Save token to localStorage
      commit("setJwt", token); // Save token to Vuex state
    },
    logout({ commit }) {
      localStorage.removeItem("traineeToken"); // Remove token from localStorage
      commit("clearJwt"); // Clear Vuex state
    }
  },
  getters: {
    isLoggedIn: state => !!state.jwt
  }
});
